
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-started/sponsor-a-scholarship",
      function () {
        return require("private-next-pages/get-started/sponsor-a-scholarship.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/get-started/sponsor-a-scholarship"])
      });
    }
  